/**
 * Created by Andrey Popov on 10/8/25.
 */

const PathTargetView = cleverapps.Spine.extend({
    ctor: function (targetUnit, options) {
        this._super(bundles.path_sign.jsons.target_json);

        this.targetUnit = targetUnit;
        const mapView = Map2d.currentMap.getMapView();

        this.setVisible(false);
        mapView.cloudsAbove.addChild(this);
        this.setLocalZOrder(mapView.getAdditionalViewLocalZOrder(targetUnit.x, targetUnit.y) - 1);

        const shape = Unit.GetShape(this.targetUnit);
        const centerOffset = MultiCellView.calcCenterPosition(shape);
        const pos = cc.pAdd(mapView.alignInGrid(this.targetUnit.x, this.targetUnit.y), centerOffset);

        const anchor = UnitView.getUnitAnchor(targetUnit);
        const size = UnitView.getUnitImage(this.targetUnit);
        this.setPosition(pos.x + size.width * (0.5 - anchor.x), pos.y + size.height * (1.1 - anchor.y));

        this.showUp(options.onShown);

        cleverapps.UI.applyHover(this);
        cleverapps.UI.onClick(this, options.onClick);
    },

    showUp: function (callback) {
        this.stopAllActions();
        this.runAction(
            new cc.Sequence(
                cleverapps.effects.fireAction("path_sign.target.appear"),
                new cc.SpineAction(this, "showUp", undefined, () => {
                    this.setAnimation(0, "idle", true);
                    callback();
                })
            )
        );
    },

    hide: function (silent) {
        if (this.isRunning()) {
            this.stopAllActions();
            if (silent) {
                this.removeFromParent();
            } else {
                this.runAction(new cc.Sequence(
                    new cc.SpineAction(this, "hide"),
                    new cc.RemoveSelf()
                ));
            }
        }
    }
});